import { ImageContent } from "@punks/core"
import React from "react"
import { RichText } from "../../../../root/punks/sanity/richText/types"
import ProductCarousel from "../../../../ui/organisms/Product/ProductCarousel"
import ProductCarouselWall, {
  ProductCarouselStyles,
} from "../../../../ui/organisms/Product/ProductCarouselWall"
import { PartialGridItemProduct } from "../../../../ui/organisms/Product/ProductGridItem/types"
import { CtaData } from "../../../../ui/types"
import { fetchAlgoliaDynamicCarousel } from "../../fetch/carousel"
import { AlgoliaDynamicCarouselDefinition } from "../../types/carousel"

type ProductCarouselLayout = "simple" | "wall"

interface Props {
  definition: AlgoliaDynamicCarouselDefinition
  title: string
  claim?: RichText
  subtitle?: string
  banner?: ImageContent
  bannerMobile?: ImageContent
  bannerSeoTitle?: string
  cta?: CtaData
  styles: ProductCarouselStyles
  layout: ProductCarouselLayout
  initialized?: boolean
}

const AlgoliaPersonalizedCarousel = ({
  definition,
  layout,
  initialized,
  ...other
}: Props) => {
  const [products, setProducts] = React.useState<PartialGridItemProduct[]>()

  const loadCarousel = async () => {
    console.log("Load carousel", definition)
    setProducts(await fetchAlgoliaDynamicCarousel(definition))
  }

  React.useEffect(() => {
    if (initialized) {
      console.log("Fetch personalization carousel")
      loadCarousel()
    }
  }, [initialized, definition])

  return (
    <>
      {products && products.length > 0 && (
        <>
          {layout === "wall" ? (
            <ProductCarouselWall products={products} {...other} />
          ) : (
            <ProductCarousel products={products} {...other} />
          )}
        </>
      )}
    </>
  )
}

export default AlgoliaPersonalizedCarousel
